import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument'
import moment from 'moment';
import { fetchPropertyCounts } from '../../store/actions/properties';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';

class PropertyDocuments extends Component {
  componentDidMount() {
    const { property, onFetchFaqsNotesDocuments, clearSearch,loader  } = this.props;
    onFetchFaqsNotesDocuments(property.propertyId,loader);
    clearSearch()
  }

  onSave = async(document) => {   
    const { user, onStartFormLoading } = this.props;
    onStartFormLoading();
    let image = null
      if(document && document.image && document.image.length > 0 && document.image[0].path){
        let path = document.image[0].path;
        let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
        image =  await upload(document.image[0], newFileName.replace(/ /g,''))
        document = document = {...document,image}
      }
    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.property.propertyId,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.id,
      DocAvailableSuitelevel: documentData.docAvailablity,
      isImportantDocument: document.isImportantDocument
    } 

   await this.props.onSaveFaqsNotesDocuments(data)
   this.props.onFetchPropertyCounts(this.props.property.propertyId, user.id, user.roles[0].role.name)

  }
  onDeleteFaqsNotesDocuments = async (document) => {
    const { user, property, onFetchPropertyCounts, onDeleteFaqsNotesDocuments } = this.props;
    document.Type = 'DOCUMENTS';
    await onDeleteFaqsNotesDocuments(document)
    onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)
  }
  render() {
    const { documents, property, setSearch, loader} = this.props;
    // Modified By: Anjali
    // Modified On: 07-11-2023
    // Modified On: 07-11-2023
    // Jira-Id: https://bosframework.atlassian.net/browse/JUN-3898
    // Reason: sort documents
    const sortDocuments = documents&&documents.length>0&&documents.sort((a, b) => {
      const firstDocumentName = a.name?.toUpperCase(); 
      const secondDocumentName = b.name?.toUpperCase();
    
      if (firstDocumentName < secondDocumentName) {
        return -1;
      }
      if (firstDocumentName > secondDocumentName) {
        return 1;
      }
      return 0;
    });
    
    return (
      loader ? <Loader /> :
      <Documents
        breadcrumb={property.name}
        documents={sortDocuments}
        from={'propertyForm'}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Manuals & Documents"}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  loader: selectPRLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onFetchPropertyCounts: fetchPropertyCounts,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyDocuments);
